<template>
    <main id="mainCtrl">
      <div style="margin-bottom: 10px;">
        <v-select v-model="selectedClinicId"
                  class="large network-clinics-select"
                  style="max-width: 750px;"
                  placeholder="Выберите клинику"
                  @select="refresh"
                  :options='clinics.map((clinic)=> {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'>
          <template v-slot="{ option }">
            <div class="textarea">
              <span>{{ option.text }}</span>
              <div style="height: 8px;"/>
              <small>{{ option.fullAddress }}</small>
            </div>
          </template>
        </v-select>
      </div>
      <TableOnlineAppointments :clinic="selectedClinic" ref="tableOnlineAppointments"/>
    </main>
</template>
<script>
import TableOnlineAppointments from "./TableComponent.vue";
export default {
  props: {
    clinics: {
      type: Array,
      required: true,
    },
  },
  components: {
    TableOnlineAppointments
  },
  data() {
    return {
      selectedClinicId: this.clinics[0].id,
    }
  },
  computed: {
    selectedClinic() {
      return this.clinics.find(item => item.id === this.selectedClinicId);
    }
  },
    methods:{
      refresh() {
        if (this.$refs.tableOnlineAppointments) {
          this.$refs.tableOnlineAppointments.updateTable()
        }
      }
    }
}
</script>
<style lang="scss">
.header-filters {
    display: flex;
    justify-content: space-between;
    &__group {
        height: 34px;
    }
}


</style>
